import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        addBlock(ctx, queryParams) {
             return new Promise((resolve, reject) => {
                axios
                    .post('/packages/v1/block/addBlock', queryParams)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateBlock(ctx, queryParams) {
            return new Promise((resolve, reject) => {
              axios
                .post(`/packages/v1/block/update/${queryParams.id}` ,queryParams.formData)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        getBlockByContentId(ctx, id) {
            return new Promise((resolve, reject) => {
              axios
                .get(`/packages/v1/block/get/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams) {
            var data = JSON.stringify(queryParams.items);

            return new Promise((resolve, reject) => {
              axios
                .post('/packages/v1/block/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        deleteBlock(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                  .delete(`/packages/v1/block/delete/${id}`)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }
    }
}